module.exports = __webpack_public_path__ + "img/lovely.444b84f7.svg";